module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/mpp/templates/companies/Company.ejs -->\n';
 var moment = require('moment') 
__p+='\n<td>'+
((__t=( model.get('companyName') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('contactName') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('contactEmail') ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( model.get('lastActiveTime') ? moment(model.get('lastActiveTime'))
            .format('DD.MM.YYYY HH:mm') : '' ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( moment(model.get('createdAt')).format('DD.MM.YYYY') ))==null?'':_.escape(__t))+
'</td>\n<td class="flex-container-row" style="overflow: visible;">\n    <a href="" class="js-login-to-company" title="Login to Company">\n        <i class="fa fa-2x fa-sign-in"></i>\n    </a>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/mpp/templates/companies/Company.ejs
// module id = 1070
// module chunks = 1